import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ButtonGroupSeparatorColorConstantType,
    ButtonGroupSeparatorDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getStateColorKey
} from "../../../../helpers/theme/state";

export const getButtonGroupSeparatorColor = ({
    variant,
    colors,
    type
}: ButtonGroupSeparatorColorConstantType): string => {
    if(variant === "filled") {
        return colors.content.container.default;
    }

    return colors.system.high[getStateColorKey({
        type
    })];
};

const stylesheet = StyleSheet.create({
    container: {
        alignSelf: "stretch",
        flexShrink: 0,
        flexGrow: 0
    }
});

export const useStyles = ({
    orientation,
    borders,
    color
}: ButtonGroupSeparatorDynamicStyleType) => {
    const styles = {
        container: {
            backgroundColor: color
        } as Mutable<ViewStyle>
    };

    if(orientation === "vertical") {
        styles.container.height = borders.separator;
    } else {
        styles.container.width = borders.separator;
    }

    return styles;
};
export default stylesheet;
